import React, { useEffect, useMemo, useState, useContext, useRef } from "react";
import { Link, json } from "react-router-dom";
import { useEntityCrud } from "../../hooks/useEntityCrud";
import { toast } from "react-toastify";
import ReactSelect from "react-select";
import { Context } from "../../context/UserContext";
import { QRCode } from 'react-qrcode-logo';
import ReactToPrint from 'react-to-print';
import "./Index.css"

const QRCodeModal = ({ ID, titleForBusiness, terminalForBusiness, phoneForBusiness }) => {

    const qrCodeContainerRef = useRef();
    let qrCodeRef = useRef();
        return (

            <div class="modal fade" id={ID}>
                <div
                    class="modal-dialog modal-dialog-centered "
                    role="document">
                    <div class="modal-content modal-content-demo">

                        <div class="modal-body text-center " style={{ margin: "0 auto" }}  >


                            <div class=" text-center qrCodeContainerRef " ref={qrCodeContainerRef} style={{ width: "148.5mm", height: "auto", margin: "0 auto" }}>


                                <img src="../../assets/images/brand/logoPetro.png" width="30%" className="my-4 mx-auto text-center" />


                                <h1 className="mb-0 py-4" style={{ fontSize: "35px" }}>
                                    <b>
                                        پرداخت با پتروکارت
                                    </b>

                                </h1>

                                <div className="topBox d-flex flex-column justify-content-center align-items-center ">

                                    <div className="">
                                        <QRCode
                                            bodyClass="mx-auto"
                                            id="QRCode"
                                            size={555}
                                            logoImage="../../assets/images/favicon.jpg"
                                            imageSettings={{
                                                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSshrGc3H1tmJPwlIDts0DaK67hMU45v6NH6y_5txdY&s",
                                                excavate: true,
                                            }}
                                            level={"L"}
                                            renderAs={"svg"}
                                            value={`https://ipg.sabinarya.com/payment/ipg/qr/app/?terminalNumber=${terminalForBusiness}&callback=https://petro.sabinarya.com`}
                                            ref={qrCodeRef}
                                        />

                                    </div>

                                </div>
                                <div className="bottomBox  d-flex flex-column justify-content-center align-items-center">
                                    <div className=" d-flex flex-column justify-content-center align-items-center">
                                        <h3 class="text-center text-bold text-dark my-4" st>
                                            <b>
                                                نام پایانه : &nbsp;
                                                {titleForBusiness || "-"}
                                            </b>


                                        </h3>
                                        <h3 class="text-center text-dark text-bold mb-4">
                                            <b>

                                                شناسه پایانه : &nbsp;
                                                {terminalForBusiness || "-"}
                                            </b>

                                        </h3>
                                    </div>
                                    <h5 class="text-center my-4 text-dark">
                                        <b>
                                            شماره پشتیبانی
                                            <span className="mx-1" dir="ltr"> {phoneForBusiness}</span>
                                        </b>
                                    </h5>

                                </div>


                            </div>

                            <ReactToPrint
                                trigger={() => {
                                    return <button
                                    className="btn btn-info btn-block mt-4"
                                 
                                >
                                    {" "}
                                    دریافت تصویر بارکد
                                </button>
                            }}
                            content={() => qrCodeContainerRef.current}
                            documentTitle={terminalForBusiness} />

                    </div>
                    
                </div>
            </div>
        </div>

    )

}
        
export default QRCodeModal; 